export default "/assets/images/mila-feed-16-thumbnail.4a47fe355aace061.jpg";